import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
import VueAxios from "vue-axios";
import Element, { Notification } from "element-ui";
import VueDataTables from "vue-data-tables";

import lang from "./libs/element_local";
import locale from "element-ui/lib/locale";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import clientStore from "./store-client";
import commonSocket from "./socket/common";
import messages from "./config/local";
import vuescroll from "vuescroll";
import "@/components/globals";
import VueMq from "vue-mq";

import "element-ui/lib/theme-chalk/index.css";
import "./styles/main.scss";
import "./styles/ritm-variables.scss";
import "handsontable/languages/ru-RU";
import "infinite-tree/dist/infinite-tree.css";

Vue.config.productionTip = false;

locale.use(lang);

Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.use(Element, { size: "small" });
Vue.use(VueDataTables);
Vue.use(clientStore);
Vue.use(commonSocket);
Vue.use(vuescroll);
Vue.use(VueMq, {
  breakpoints: {
    r_medium: 1800,
    r_large: Infinity
  }
});

const LOCALE = store.getters.getLocale;
const i18n = new VueI18n({
  fallbackLocale: LOCALE,
  locale: LOCALE,
  silentTranslationWarn: true,
  messages
});

Vue.prototype.$notify = Notification;

Vue.directive("focus", {
  inserted: function(el) {
    el.focus();
  }
});

export default new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
